import { DialogEnum } from '../enumerators/messages.enum';
import { DialogOption } from './dialog-option.model';

export class Dialog {
    public type: DialogEnum = DialogEnum.Normal;
    public title: string = "";
    public message: string = "";
    public size: number = 40;
    public options: Array<DialogOption> = [];

    constructor(init?: Partial<Dialog>) {
        Object.assign(this, init);
    }
}
